export default __webpack_public_path__ + "images/models/5362501302b24f3626a06a24092129f4.glb";